import { render, staticRenderFns } from "./EditGameDialog.vue?vue&type=template&id=b0ea88cc"
import script from "./EditGameDialog.vue?vue&type=script&lang=js"
export * from "./EditGameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports